import React, { useEffect, useMemo, useState } from 'react'
import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, CircularProgress, Typography, Stack, Link, TablePagination, Button, Box,
} from '@mui/material'


interface Props {
  subscriber: any
}

export const AdminsActions: React.FC<Props> = ({ subscriber }) => {
  const invoices = subscriber?.history ?? []
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const rowsPerPage = 5

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number) => {
    setPage(newPage)
  }
  const sortedInvoices = [...invoices].sort((a, b) => {
    return new Date(b.paidOn || 0).getTime() - new Date(a.paidOn || 0).getTime()
  })

  const totalPayments = invoices.length

  const paginatedInvoices = useMemo(() => {
    const start = page * rowsPerPage
    const end = start + rowsPerPage

    return sortedInvoices.slice(start, end)
  }, [page, rowsPerPage, sortedInvoices])

  useEffect(() => {
    if (Array.isArray(invoices)) {
      setLoading(false)
    }
  }, [invoices])

  if (loading) return <CircularProgress />
  if (!invoices.length) return <></>

  const formatDateTime = (dateStr: string) => {
    const d = new Date(dateStr)
    const pad = (n: number) => n.toString().padStart(2, '0')

    const day = pad(d.getDate())
    const month = pad(d.getMonth() + 1)
    const year = d.getFullYear()

    const hours = pad(d.getHours())
    const minutes = pad(d.getMinutes())
    const seconds = pad(d.getSeconds())

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
  }

  const getBackgroundColorByAction = (action: string): string => {
    switch (action) {
      case 'package_change':
        return '#E6F4EA'
      case 'balance_change':
        return '#D1E9FC'
      case 'renewal_date_change':
        return '#FFF4E5'
      default:
        return '#F5F5F5'
    }
  }

  return (
    <Stack>
      <Typography variant="h6" gutterBottom>
        Total admin actions count:{' '}
        <span style={{ color: 'red' }}>{totalPayments}</span>
      </Typography>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center"><strong>Admin</strong></TableCell>
                <TableCell align="center"><strong>Action</strong></TableCell>
                <TableCell align="center"><strong>Date\Time</strong></TableCell>
                <TableCell align="center"><strong>Type</strong></TableCell>
                {/* <TableCell align="center"><strong>Details</strong></TableCell> */}
                
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedInvoices.map((story, index) => (
                <TableRow key={story.id}
                  sx={{ backgroundColor: getBackgroundColorByAction(story.action) }} >
                  <TableCell align="center">{story.adminLogin}</TableCell>
                  <TableCell align="center">{story.message}</TableCell>
                  <TableCell align="center"> {story.createdTime ? formatDateTime(story.createdTime) : '—'}               
                  </TableCell>
                  <TableCell align="center">{story.action}</TableCell>
                  {/* <TableCell align="center">
                    <Button variant="contained" color="primary" style={{ width: 30, height: 30, minWidth: 0, borderRadius: '50%', padding: 0 }} >
                      <OpenInNewIcon style={{ width: 16, height: 16 }} /> 
                      </Button>
                  </TableCell> */}
                </TableRow>))
              }
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination component="div" count={sortedInvoices.length} page={page} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} rowsPerPageOptions={[]} />
      </Paper>
    </Stack>

  )
}

